/* Global theme behavior: mobile menu, smooth scroll, announcement rotation, toasts. */
(function () {
  'use strict';

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }
    });
  }

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-smooth-scroll]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var headerOffset = document.querySelector('[data-site-header]');
      var offset = headerOffset ? headerOffset.offsetHeight + 12 : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  function initAnnouncementRotation() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-rotate'), 10) || 4000;
    var index = 0;
    setInterval(function () {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, interval);
  }

  window.showToast = function (message, opts) {
    opts = opts || {};
    var toast = document.getElementById('quick-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    if (opts.error) toast.classList.add('is-error'); else toast.classList.remove('is-error');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, opts.duration || 3000);
  };

  window.trackEvent = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    }
  };

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count === 0) el.setAttribute('data-zero', ''); else el.removeAttribute('data-zero');
    });
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') updateCartCount(e.detail.item_count);
  });

  function initUgcVideos() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ugc-toggle]');
      if (!btn) return;
      var card = btn.closest('[data-ugc-card]');
      var video = card && card.querySelector('video');
      if (!video) return;
      if (video.paused) {
        video.play();
        video.muted = false;
        btn.setAttribute('aria-label', 'Pause video');
        window.trackEvent('ugc_played');
      } else {
        video.pause();
        video.muted = true;
        btn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  function init() {
    initMobileMenu();
    initSmoothScroll();
    initAnnouncementRotation();
    initUgcVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
